"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiSchema = {
    type: "VerticalLayout",
    elements: [{ type: "Control", scope: "#/properties/notes" }],
};
exports.default = uiSchema;
